// extracted by mini-css-extract-plugin
module.exports = {"menu":"BottomMenu_menu__Yw_33","item":"BottomMenu_item__1ouuD","submenu":"BottomMenu_submenu__2E7iE","chevron":"BottomMenu_chevron__2XkAo"};